import {
  Button,
  IconButton,
  MenuItem,
  MenuList,
  Modal,
  Typography,
  Divider,
  List,
  ListItem,
  CircularProgress,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Box } from "@mui/system";
import React, { useCallback, useEffect, useState } from "react";
import { BsSearch } from "react-icons/bs";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import InputBase from "@mui/material/InputBase";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Popover from "@mui/material/Popover";
import Checkbox from "@mui/material/Checkbox";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import api from "../../services/CBT";
import AddSetUp from "./Modals/AddSetUp";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { FormateDate } from "../../utils";
import EditSetUp from "./Modals/EditSetup";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { lg: 800, xs: 400 },
  height: "600px",
  bgcolor: "background.paper",
  borderRadius: "10px",
  border: "1px solid #671E78",
  boxShadow: 24,
  p: 4,
  overflowY: "scroll",
};
const theme = createTheme({
  palette: {
    primary: {
      main: "#671E78",
    },
  },
});

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  backgroundColor: "#FFF",

  border: "1px solid #691e78",
  borderRadius: "100px",
  "&:hover": {
    // backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "345px",

  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
  },
}));
export const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: "rgba(103, 30, 120, 0.1)",
    fontFamily: "Gilroy-Bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Gilroy-Regular",
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: " rgba(103, 30, 120, 0.1)",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const CBTFirst = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const { admToken, user } = useSelector((state) => state.auth);
  const [setupData, setSetupData] = useState(null);
  const [classes, setClasses] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [activationStatus, setActivationStatus] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingAssignClasses, setLoadingAssignClasses] = useState(false);
  const [openAddClass, setOpenAddClass] = React.useState(false);

  const handleOpenModal = () => setOpenModal(true);

  const handleCloseAddClass = () => setOpenAddClass(false);

  const [openEdit, setOpenEdit] = React.useState(false);

  const handleOpenEdit = () => setOpenEdit(true);

  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
  };

  const getDataCTBSetup = useCallback(async () => {
    try {
      const res = await api.getCBTSetUp(admToken, user.schoolId,);
      if (res.status && res.statusCode === 2) {
        setSetupData(res.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error.response);
      setLoading(false);
      console.log("error");
    }
  }, [admToken]);

  const getAssignClass = useCallback(async () => {
    try {
      const res = await api.getAssignClasses(admToken, user.schoolId, selectedItem?.id);
      if (res.status && res.statusCode === 2) {
        setClasses(res.data);

        const initiallySelected = res.data
          .filter(cls => cls.isClassAssign)
          .map(cls => cls.classId);
        setSelectedClasses(initiallySelected);
      }
      setLoading(false);
    } catch (error) {
      console.log(error.response);
      setLoading(false);
      console.log("error");
    }
  }, [admToken, user.schoolId, selectedItem?.id]);


  const handleClassToggle = (classId) => {
    setSelectedClasses(prev => {
      if (prev.includes(classId)) {
        return prev.filter(id => id !== classId);
      } else {
        return [...prev, classId];
      }
    });
  };

  const handleOpenAddClass = () => {
    setOpenAddClass(true);
    getAssignClass();
  }

  const assignClasses = useCallback(async () => {
    try {
      setLoadingAssignClasses(true);

      const payload = {
        staffId: user?.staffId,
        schoolId: user.schoolId,
        setupId: selectedItem?.id,
        classesIds: classes
          .filter(cls =>
            selectedClasses.includes(cls.classId) || cls.isAssigned
          )
          .map(cls => ({
            classId: cls.classId,
            isClassAssign: selectedClasses.includes(cls.classId),
          })),
      };

      const res = await api.assignClasses(admToken, payload);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message, {
          autoClose: 4000,
          position: toast.POSITION.BOTTOM_LEFT,
        });
        handleCloseAddClass();
        getDataCTBSetup();
      }
    } catch (error) {
      console.log(error.response);
    } finally {
      setLoadingAssignClasses(false);
    }
  }, [admToken, user, selectedItem?.id, classes, selectedClasses]);


  const deleteSetup = useCallback(async (id) => {
    try {
      const res = await api.deleteCBTSetUp(admToken, id);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message, {
          autoClose: 4000,
          position: toast.POSITION.BOTTOM_LEFT,
        });
        getDataCTBSetup();
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed to delete setup");
      setLoading(false);
      console.log("error");
      handleClose();
    } finally {
      setLoading(false);
    }
  }, [admToken]);

  useEffect(() => {
    getDataCTBSetup();
    getAssignClass();
  }, [getDataCTBSetup, getAssignClass]);

  const handleCloseModal = () => {
    setOpenModal(false)
    getDataCTBSetup();
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
    getDataCTBSetup();
  };

  const handleActivation = useCallback(async (id) => {
    try {
      const currentStatus = activationStatus[id];
      const newStatus = !currentStatus;

      const res = await api.activateDeactive(admToken, id, newStatus);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message, {
          autoClose: 4000,
          position: toast.POSITION.BOTTOM_LEFT,
        });
        setActivationStatus(prev => ({
          ...prev,
          [id]: newStatus
        }));
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed to update activation status");
    }
  }, [admToken, activationStatus]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress size={60} sx={{ color: "#671E78" }} />
      </Box>
    );
  }

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Box align="right" sx={{ my: 2 }}>
          <Button
            onClick={handleOpenModal}
            variant="contained"
            sx={{
              textTransform: "initial",
              fontFamily: "Gilroy-Bold",
              height: "50px",
              px: 7,
              py: 0.5,
            }}
          >
            CBT Set Up
          </Button>
        </Box>
        <Box
          mt={5}
          sx={{
            border: "1px solid #671E78",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              borderRadius: "20px 20px 0px 0px",
              pt: 4,
              background: "rgba(103, 30, 120, 0.1)",
              height: "100px",
              pl: { xs: 2.5 },
            }}
          >
            <Search
              sx={{
                width: {
                  lg: "345px",
                  md: "330px",
                  sm: "auto",
                  xs: "auto",
                  pl: { xs: 6 },
                },
              }}
            >
              <SearchIconWrapper>
                <BsSearch />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ "aria-label": "search" }}
              />
            </Search>
          </Box>
          <TableContainer>
            <Table
              sx={{ minWidth: 700, fontFamily: "Gilroy-Regular" }}
              aria-label="customized table"
            >
              <TableHead
                sx={{
                  backgroundColor: "rgba(103, 30, 120, 0.1)",
                  width: "100%",
                }}
              >
                <TableRow>
                  <StyledTableCell>S/N</StyledTableCell>
                  <StyledTableCell>Posted Title</StyledTableCell>
                  <StyledTableCell>Date</StyledTableCell>
                  <StyledTableCell>Quiz Type</StyledTableCell>
                  <StyledTableCell>Subject</StyledTableCell>
                  <StyledTableCell>Duration</StyledTableCell>
                  <StyledTableCell>Created By</StyledTableCell>
                  <StyledTableCell></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody sx={{ fontFamily: "Gilroy-Regular" }}>
                {setupData?.map((data, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell component="th" scope="row">
                      {index + 1}
                    </StyledTableCell>
                    <StyledTableCell>{data.title}</StyledTableCell>
                    <StyledTableCell>{data?.postedDate ? FormateDate(data.postedDate) : "N/A"}</StyledTableCell>
                    <StyledTableCell>{data.quizType}</StyledTableCell>
                    <StyledTableCell>{data.subject}</StyledTableCell>
                    <StyledTableCell>{data.duration}</StyledTableCell>
                    <StyledTableCell>{data.postedBy}</StyledTableCell>

                    <StyledTableCell>
                      <IconButton onClick={(event) => handleClick(event, data)}>
                        <MoreVertIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Box
            sx={{
              bgcolor: "#671E78",
              color: "#fff",
              fontFamily: "Gilroy-Regular",
              px: 3,
            }}
          >
            <MenuList sx={{ fontFamily: "Gilroy-Regular" }}>
              <MenuItem
                onClick={handleOpenAddClass}
                sx={{ fontFamily: "Gilroy-Regular" }}
              >
                Add Class
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: "Gilroy-Regular" }}
                onClick={() => {
                  if (selectedItem) {
                    handleActivation(selectedItem.id);
                    handleClose();
                  }
                }}
              >
                {selectedItem && activationStatus[selectedItem.id] ? "Deactivate" : "Activate"}
              </MenuItem>
              <Link
                to={`/cbt/addquestion/${selectedItem?.subjectId}/${selectedItem?.id}/${encodeURIComponent(selectedItem?.subject)}/${encodeURIComponent(selectedItem?.title)}`}
              >
                <MenuItem sx={{ fontFamily: "Gilroy-Regular" }}>
                  Add/View Questions
                </MenuItem>
              </Link>
              <Link to={`/cbt/submission/${encodeURIComponent(selectedItem?.subject)}/${encodeURIComponent(selectedItem?.title)}/${selectedItem?.id}`}>
                <MenuItem sx={{ fontFamily: "Gilroy-Regular" }}>
                  View Submission
                </MenuItem>
              </Link>
              <Link to={`/cbt/viewtest/${selectedItem?.id}/${selectedItem?.subjectId}/${encodeURIComponent(selectedItem?.subject)}/${encodeURIComponent(selectedItem?.title)}/${selectedItem?.duration}`}>
                <MenuItem sx={{ fontFamily: "Gilroy-Regular" }}>
                  View Test
                </MenuItem>
              </Link>
              <MenuItem
                sx={{ fontFamily: "Gilroy-Regular" }}
                onClick={handleOpenEdit}
              >
                Edit
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: "Gilroy-Regular" }}
                onClick={() => {
                  if (selectedItem) {
                    deleteSetup(selectedItem.id);
                  }
                }}
              >
                Delete
              </MenuItem>
            </MenuList>
          </Box>
        </Popover>
      </Box>
      {/* Create */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box align="right" sx={{}}>
            <IconButton onClick={handleCloseModal}>
              <HighlightOffIcon />
            </IconButton>
          </Box>
          <Box>
            <Typography
              variant="h4"
              sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}
            >
              CBT set up
            </Typography>
            <Divider />
          </Box>
          <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
            <AddSetUp onSuccess={handleCloseModal} />
          </Box>
        </Box>
      </Modal>
      {/* //edit */}
      <Modal
        open={openEdit}
        onClose={handleCloseEdit}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box align="right" sx={{}}>
            <IconButton onClick={handleCloseEdit}>
              <HighlightOffIcon />
            </IconButton>
          </Box>
          <Box>
            <Typography
              variant="h4"
              sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}
            >
              Edit set Up
            </Typography>
            <Divider />
          </Box>
          <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
            <EditSetUp onSuccess={handleCloseEdit} item={selectedItem} />
          </Box>
        </Box>
      </Modal>
      {/* assign classes */}
      <Modal
        open={openAddClass}
        onClose={handleCloseAddClass}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box align="right" sx={{}}>
            <IconButton onClick={handleCloseAddClass}>
              <HighlightOffIcon />
            </IconButton>
          </Box>
          <Box>
            <Typography
              variant="h4"
              sx={{ textAlign: "center", mb: 1, fontFamily: "Gilroy-Medium" }}
            >
              Assign Class
            </Typography>
            <Typography
              variant="body1"
              sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Regular" }}
            >
              {selectedItem?.subject || ""}
            </Typography>
            <Divider />
          </Box>
          <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
            <List>
              {classes.map((cls) => (
                <ListItem key={cls.classId}>
                  <Checkbox
                    checked={selectedClasses.includes(cls.classId)}
                    onChange={() => handleClassToggle(cls.classId)}
                  />
                  <Typography
                    variant="caption"
                    sx={{ fontFamily: "Gilroy-Medium" }}
                  >
                    {cls.className}
                  </Typography>
                </ListItem>
              ))}
            </List>
            <Box mt={5}>
              <Button
                variant="contained"
                fullWidth
                sx={{ textTransform: "initial" }}
                onClick={assignClasses}
                disabled={loadingAssignClasses}
              >
                {loadingAssignClasses ? "Assigning" : "Assign Class"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </ThemeProvider>
  );
};

export default CBTFirst;
